<template>
    <div style="height: 100vh">
        <div id="index" ref="appRef">
            <div class="bg">
                <dv-loading v-if="loading">Loading...</dv-loading>
                <div v-else class="host-body" style="height: 100%; overflow: hidden;">
                    <div class="d-flex jc-center">
                        <dv-decoration-10 class="dv-dec-10"/>
                        <div class="d-flex jc-center">
                            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#000000']"/>
                            <div class="title">
                                <span class="title-text">三高共管监管平台</span>
                                <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']"/>
                            </div>
                            <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="['#568aea', '#000000']"/>
                        </div>
                        <dv-decoration-10 class="dv-dec-10-s"/>
                    </div>
                    <div class="body-box" style="height:calc(100% - 100px);margin-top: 35px; overflow: hidden;">
                        <div class="content-box-gl" style="height: 100%;">
                            <div style="">
                                <dv-border-box-13 v-if="barshow">
                                    <div class="barbox">
                                        <div class="bg-color-black">
                                            <Echart :options="baroptions" v-if="barshow" id="glbarcategorystack"
                                                    height="100%" width="100%" ref="glbarcategorystack"
                                                    @acceptDom="acceptDom">
                                            </Echart>
                                        </div>
                                    </div>
                                    <div class="content-title">
                                        <span v-if="type == 1">三高患者管理数量</span>
                                        <span v-if="type == 2">三高患者随访服务</span>
                                    </div>
                                </dv-border-box-13>
                                <dv-border-box-13 v-if="drugshow">
                                    <div class="barbox">
                                        <div class="bg-color-black">
                                            <Echart :options="drugoptions" v-if="drugshow" id="gldrugcategorystack"
                                                    height="100%" width="100%" ref="gldrugcategorystack"
                                                    @acceptDom="acceptDrug"></Echart>
                                        </div>
                                    </div>
                                    <div class="content-title"><span>三高患者服药情况</span></div>
                                </dv-border-box-13>
                                <dv-border-box-13 v-if="pieshow">
                                    <div class="barbox">
                                        <div class="bg-color-black" style="display:flex;flex-wrap: wrap;">
                                            <EchartPie :options="piegxy" v-if="pieshow" id="glpiecategorystack"
                                                       height="50%"
                                                       width="33%" ref="glpiecategorystack"></EchartPie>
                                            <EchartPie :options="pietnb" v-if="pieshow" id="glpiecategorystack2"
                                                       height="50%"
                                                       width="34%" ref="glpiecategorystack"></EchartPie>
                                            <EchartPie :options="pieg_t" v-if="pieshow" id="glpiecategorystack3"
                                                       height="50%"
                                                       width="33%" ref="glpiecategorystack"></EchartPie>
                                            <EchartPie :options="pieg_z" v-if="pieshow" id="glpiecategorystack4"
                                                       height="50%"
                                                       width="33%" ref="glpiecategorystack"></EchartPie>
                                            <EchartPie :options="piet_z" v-if="pieshow" id="glpiecategorystack5"
                                                       height="50%"
                                                       width="34%" ref="glpiecategorystack"></EchartPie>
                                            <EchartPie :options="piesgg" v-if="pieshow" id="glpiecategorystack6"
                                                       height="50%"
                                                       width="33%" ref="glpiecategorystack"></EchartPie>
                                        </div>
                                    </div>
                                    <div class="content-title">
                                        <span v-if="type == 1">三高患者管理数量地区分布</span>
                                        <span v-if="type == 2">三高患者随访服务地区分布</span>
                                    </div>
                                </dv-border-box-13>
                            </div>
                            <div class="btn-box">
                                <div class="button-style" @click="getdata(1)">管理数量</div>
                                <div v-if="type == 1" class="button-style" @click="getdata(4)">
                                    地区分布(管理)
                                </div>
                                <div v-if="type == 2" class="button-style" @click="getdata(4)">
                                    地区分布(随访)
                                </div>
                                <div class="button-style" @click="getdata(2)">随访服务</div>
                                <div class="button-style" @click="getdata(3)">服药情况</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import drawMixin from '../utils/drawMixin';
    import {
        formatTime
    } from '../utils/index.js';
    import request from '@/utils/request';
    import Echart from '@/common/echart';
    import EchartPie from '@/common/echart/pie'

    export default {
        mixins: [drawMixin],
        data() {
            return {
                timing: null,
                loading: true,
                dateDay: null,
                dateYear: null,
                dateWeek: null,
                weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                count: '',
                // 柱状图options
                baroptions: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#fff",
                                opacity: 0.1,
                            },
                        },
                    },
                    yAxis: {
                        type: 'category',
                        inverse: true, //是否是反向坐标轴
                        axisLine: {
                            show: false
                        },
                        data: [],
                        axisLabel: {
                            textStyle: {
                                fontSize: 14
                            },
                        },

                    },
                    series: []
                },
                //药品信息
                drugoptions: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        axisLine: {
                            show: false, //隐藏y轴
                        },
                        axisLabel: {
                            show: false, //隐藏刻度值
                        },
                    },
                    yAxis: {
                        type: 'category',
                        inverse: true, //是否是反向坐标轴
                        data: [],
                        axisLine: {
                            show: false, //隐藏y轴
                        },
                        axisLabel: {
                            textStyle: {
                                fontSize: 14
                            },
                        },
                    },
                    dataZoom: [
                        {
                            yAxisIndex: 0,// 这里是从X轴的0刻度开始
                            show: false, // 是否显示滑动条，不影响使用
                            type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                            startValue: 0, // 从头开始。
                            endValue: 30, // 一次性展示多少个。
                        },
                    ],
                    series: [
                        {
                            type: 'bar',
                            data: [],

                            label: {
                                //这线后显示
                                show: true,
                                position: "right",
                                color: '#fff',
                                fontSize: '16px'
                            },
                        }
                    ]
                },
                otherData: [],
                drugChart: "",
                barChart: "",
                piegxy: {},
                pietnb: {},
                pieg_t: {},
                pieg_z: {},
                piet_z: {},
                piesgg: {},
                // 饼图options
                pieoptions: {
                    title: {
                        text: "",
                        left: 'center',
                        bottom: '15px'
                    },
                    tooltip: {
                        trigger: 'item',
                    },
                    legend: {
                        type: 'scroll',
                        data: [],

                    },
                    series: [{
                        type: 'pie',
                        radius: '45%',
                        center: ["46%", "55%"],
                        /* radius: [55, 65],
                        center: ['50%','50%'],
                        roseType: 'area', */
                        label: {
                            normal: {
                                textStyle: {
                                    fontSize: 14
                                },
                                show: true,
                                formatter: '{b}:{c}人',  // 标签内容"
                                margin: 10

                            },

                        },
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                },
                barshow: false,
                pieshow: false,
                drugshow: false,
                timeOut: "",
                type: 1
            };
        },
        components: {
            Echart,
            EchartPie
        },
        mounted() {
            this.timeFn();
            this.cancelLoading();
            this.getdata(1)
        },
        beforeDestroy() {
        },
        methods: {
            acceptDom(chart) {
                this.barChart = chart;
            },
            acceptDrug(chart) {
                this.drugChart = chart;
            },
            getdata(type) {
                /* 清空数据 */
                this.baroptions.yAxis.data = [];
                this.baroptions.series = [];
                if (type == 1 || type == 2) {
                    this.type = type
                }
                let jgbm = this.$route.query.jgbm;
                let area = this.$route.query.type; /* 范围 */
                let code = this.$route.query.code;
                if (type == 1 || type == 2) {
                    this.barshow = true;
                    this.pieshow = false;
                    this.drugshow = false;
                    request({
                        url: this.$root.api + `/api/dbz/TehrReportSggg/daping`,
                        method: 'get',
                        data: {
                            jgbm: jgbm,
                            tjlx: type,
                            type: area,
                            code: code
                        }
                    }).then(res => {
                        console.log(res);
                        this.baroptions.series = res.data.series
                        this.baroptions.yAxis.data = res.data.yAxis.data
                    });
                }
                if (type == 3) {
                    clearInterval(this.timeOut);
                    this.barshow = false
                    this.pieshow = false
                    this.drugshow = true
                    request({
                        url: this.$root.api + `/api/dbz/TehrReportSggg/daping/Yyzd`,
                        method: 'get',
                        data: {
                            jgbm: jgbm,
                            tjlx: type,
                            type: area,
                            code: code
                        }
                    }).then(res => {
                        //console.log(res.data.series[1].data)
                        this.drugoptions.series[0].data = res.data.series[1].data;
                        this.drugoptions.yAxis.data = res.data.series[0].data;
                    });

                    this.timeOut = setInterval(() => {
                        // 如果轮播完了则回到开始
                        if (this.drugoptions.dataZoom[0].endValue == this.drugoptions.series[0].data.length) {
                            this.drugoptions.dataZoom[0].endValue = 30;
                            this.drugoptions.dataZoom[0].startValue = 0;
                        } else {
                            this.drugoptions.dataZoom[0].endValue = this.drugoptions.dataZoom[0].endValue + 1;
                            this.drugoptions.dataZoom[0].startValue = this.drugoptions.dataZoom[0].startValue + 1;
                        }
                    }, 3000)
                }
                if (type == 4) {
                    let tjlx = 1;
                    if (this.type == 1)
                        tjlx = 1;
                    if (this.type == 2)
                        tjlx = 2
                    this.barshow = false
                    this.pieshow = true
                    this.drugshow = false
                    request({
                        url: this.$root.api + `/api/dbz/TehrReportSggg/daping/bingtu`,
                        method: 'get',
                        data: {
                            jgbm: jgbm,
                            tjlx: tjlx,
                            type: area,
                            code: code
                        }
                    }).then(res => {
                        console.log('pie----', res);
                        let gxyData = [];
                        let tnbData = [];
                        let tnbName = [];
                        let g_tData = [];
                        let g_zData = [];
                        let t_zData = [];
                        let sggData = [];
                        this.otherData = res.data.otherData;
                        this.otherData.forEach(child => {
                            child.forEach((item, ol) => {
                                const {fatherName: name, toolValue: value} = item
                                const newObj = {name, value}
                                if (ol == 0) {
                                    gxyData.push(newObj);
                                }
                                if (ol == 1) {
                                    tnbData.push(newObj);
                                    tnbName.push(newObj.name)
                                }
                                if (ol == 2) {
                                    g_tData.push(newObj);
                                }
                                if (ol == 3) {
                                    g_zData.push(newObj);
                                }
                                if (ol == 4) {
                                    t_zData.push(newObj);
                                }
                                if (ol == 5) {
                                    sggData.push(newObj);
                                }
                            })
                        });
                        let that = this;
                        that.piegxy = JSON.parse(JSON.stringify(that.pieoptions));
                        that.piegxy.series[0].data = gxyData;
                        that.piegxy.title.text = '高血压';
                        that.piegxy.series[0].label.normal.formatter = function (v) {
                            return v.name.length > 6 ? v.name.slice(0, 6) + '...' + v.value + '人' : v.name + v.value + '人';
                        }

                        that.pietnb = JSON.parse(JSON.stringify(that.pieoptions));
                        that.pietnb.series[0].data = tnbData;
                        that.pietnb.legend.data = tnbName;
                        that.pietnb.title.text = '糖尿病';
                        that.pietnb.series[0].label.normal.formatter = function (v) {
                            return v.name.length > 6 ? v.name.slice(0, 6) + '...' + v.value + '人' : v.name + v.value + '人';
                        }

                        that.pieg_t = JSON.parse(JSON.stringify(that.pieoptions));
                        that.pieg_t.series[0].data = g_tData;
                        that.pieg_t.title.text = '高血压并糖尿病';
                        that.pieg_t.series[0].label.normal.formatter = function (v) {
                            return v.name.length > 6 ? v.name.slice(0, 6) + '...' + v.value + '人' : v.name + v.value + '人';
                        }

                        that.pieg_z = JSON.parse(JSON.stringify(that.pieoptions));
                        that.pieg_z.series[0].data = g_zData;
                        that.pieg_z.title.text = '高血压并高血脂';
                        that.pieg_z.series[0].center = ['45%', '50%']
                        that.pieg_z.series[0].label.normal.formatter = function (v) {
                            return v.name.length > 6 ? v.name.slice(0, 6) + '...' + v.value + '人' : v.name + v.value + '人';
                        }

                        that.piet_z = JSON.parse(JSON.stringify(that.pieoptions));
                        that.piet_z.series[0].data = t_zData;
                        that.piet_z.title.text = '糖尿病并高血脂';
                        that.piet_z.series[0].center = ['45%', '50%']
                        that.piet_z.series[0].label.normal.formatter = function (v) {
                            return v.name.length > 6 ? v.name.slice(0, 6) + '...' + v.value + '人' : v.name + v.value + '人';
                        }

                        that.piesgg = JSON.parse(JSON.stringify(that.pieoptions));
                        that.piesgg.series[0].data = sggData;
                        that.piesgg.title.text = '三高';
                        that.piesgg.series[0].center = ['45%', '50%']
                        that.piesgg.series[0].label.normal.formatter = function (v) {
                            return v.name.length > 6 ? v.name.slice(0, 6) + '...' + v.value + '人' : v.name + v.value + '人';
                        }

                        var tooltip = {
                            trigger: 'item',
                            textStyle: {
                                fontSize: 18 // 字体大小
                            },
                        }
                        that.pieoptions.tooltip = tooltip
                        that.$nextTick(() => {
                            that.$refs.glpiecategorystack.chart.resize();
                        })
                    });
                }
            },
            timeFn() {
                this.timing = setInterval(() => {
                    this.dateDay = formatTime(new Date(), 'HH: mm: ss');
                    this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
                    this.dateWeek = this.weekday[new Date().getDay()];
                }, 1000);
            },
            cancelLoading() {
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            }
        }
    };
</script>

<style lang="scss">
    @import '../assets/scss/index.scss';

    #index {
        overflow: hidden;
    }

    .barbox {
        position: relative;
        padding: 20px 16px;
        height: 97%;
        width: 100%;
        border-radius: 5px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;

        .bg-color-black {
            height: 100%;
            border-radius: 10px;
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }

    .content-title {
        height: 4%;
        width: 98%;
        margin: auto;
        margin-top: -1.3%;
        background: linear-gradient(left, #1B3651, #03050C);
        background: -webkit-linear-gradient(left, #1B3651, #03050C);
        border-bottom-left-radius: 10px;

        span {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: .7%;
            font-size: 17px;
            //margin-top: 5px;
        }
    }

    .btn-box {
        flex-direction: column;
        display: flex;
        justify-content: space-between;
        height: 100%;
        padding-top: 100px;
        padding-bottom: 100px;
        overflow: hidden;
        padding-left: 25px;
        box-sizing: border-box;
    }

    .button-style {
        cursor: pointer;
        width: 180px;
        height: 30px;
        position: relative;
        overflow: hidden;
        background: #409EFF;
        border-radius: 5px;
        text-align: center;
        line-height: 30px;
        color: #fff !important;

    }
</style>
